import { render, staticRenderFns } from "./commentPanel.vue?vue&type=template&id=56c736aa&scoped=true"
import script from "./commentPanel.vue?vue&type=script&lang=js"
export * from "./commentPanel.vue?vue&type=script&lang=js"
import style0 from "./commentPanel.vue?vue&type=style&index=0&id=56c736aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c736aa",
  null
  
)

export default component.exports